import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@bonusly/design-system';

import { isMacOS } from '../../utils/agent';
import { Key } from '../Keyboard';

export const TooltipContent: FC = memo(() => {
	const { t } = useTranslation(['navigation', 'common']);

	return (
		<Box as="span" display="inline-flex" alignItems="center">
			{t('navigation:search.trigger_tooltip')}{' '}
			<Key color="gray.500" fontSize="sm" ml={1}>
				{isMacOS() ? '⌘' : t('common:ctrl_key')}
			</Key>{' '}
			+{' '}
			<Key color="gray.500" fontSize="sm">
				K
			</Key>
		</Box>
	);
});

TooltipContent.displayName = 'TooltipContent';
